import React from 'react';
import { MenuProps } from "antd";

export const LabelMainMenuItems: any = {
  // product: {
  //   label: "Products",
  //   key: "products",
  //   children: [
  //     {
  //       label: "Product Search",
  //       key: "product-search"
  //     },
  //     {
  //       label: "Product Viewer",
  //       key: "product-viewer"
  //     },
  //     {
  //       label: "Product Tracking",
  //       key: "product-tracking"
  //     }
  //   ]
  // },
  // seller: {
  //   label: "Sellers",
  //   key: "sellers",
  //   children: [
  //     {
  //       label: "Seller Storefront",
  //       key: "seller-storefront"
  //     },
  //     {
  //       label: "Top Rated Sellers",
  //       key: "top-rated-sellers"
  //     }
  //   ]
  // },
  pricing: {
    label: "Pricing Plans",
    key: "pricing-plans"
  },
  history: {
    label: "History",
    key: "history",
    children: [
      {
        label: "Team History",
        key: "team-history",
        link: "/user/team-history"
      },
      {
        label: "Buy Sell History",
        key: "buy-sell-history",
        link: "/user/buy-sell-history"
      }
    ]
  },
  googleAddon: {
    label: <a href="https://asinzen.com/get-to-know-addon/" target="_blank" rel="noopener noreferrer">Google Add-on</a>,
    key: "external", // if open a new tab, this one is always "external"
  },
  wholesalesSuppliers: {
    label: "Wholesale Suppliers",
    key: "wholesale-suppliers",
    children: [
      {
        label: "Search Wholesale suppliers",
        key: "search-wholesale-suppliers",
        link: "/wholesale-suppliers/search"
      },
      {
        label: "Newest Wholesale suppliers",
        key: "newest-wholesale-suppliers",
        link: "/wholesale-suppliers/newest"
      },
      {
        label: "My Saved Wholesale suppliers",
        key: "my-saved-wholesale-suppliers",
        link: "/wholesale-suppliers/my-saved"
      },
    ]
  },
};

export const LinkMenuItems = [
  // {
  //   label: "Product Search",
  //   key: "product-search",
  //   parent: LabelMainMenuItems.product.key,
  //   link: "/"
  // },
  // {
  //   label: "Product Viewer",
  //   key: "product-viewer",
  //   parent: LabelMainMenuItems.product.key,
  //   link: "/az-api/product-viewer"
  // },
  // {
  //   label: "Product Tracking",
  //   key: "product-tracking",
  //   parent: LabelMainMenuItems.product.key,
  //   link: "/az-api/product-tracking"
  // },
  // {
  //   label: "Seller Storefront",
  //   key: "seller-storefront",
  //   parent: LabelMainMenuItems.seller.key,
  //   link: "/az-api/seller-storefront"
  // },
  // {
  //   label: "Top Rated Sellers",
  //   key: "top-rated-sellers",
  //   parent: LabelMainMenuItems.seller.key,
  //   link: "/az-api/top-rated-sellers"
  // },
  {
    label: "Pricing Plans",
    key: "pricing-plans",
    parent: LabelMainMenuItems.pricing.key,
    link: "/pricing-plans"
  },
  {
    label: "Team History",
    key: "team-history",
    parent: LabelMainMenuItems.history.key,
    link: "/user/team-history"
  },
  {
    label: "Buy Sell History",
    key: "buy-sell-history",
    parent: LabelMainMenuItems.history.key,
    link: "/user/buy-sell-history"
  },
  {
    label: "Search Wholesale Suppliers",
    key: "search-wholesale-suppliers",
    parent: LabelMainMenuItems.wholesalesSuppliers.key,
    link: "/wholesale-suppliers/search"
  },
  {
    label: "Newest Wholesale suppliers",
    key: "newest-wholesale-suppliers",
    parent: LabelMainMenuItems.wholesalesSuppliers.key,
    link: "/wholesale-suppliers/newest"
  },
  {
    label: "My Saved Wholesale suppliers",
    key: "my-saved-wholesale-suppliers",
    parent: LabelMainMenuItems.wholesalesSuppliers.key,
    link: "/wholesale-suppliers/my-saved"
  },
];
